<!--  -->
<template>
  <div class="dsawr">
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="id"
        label="Id"
        width="180"
        align="center"
      />
      <el-table-column
        prop="turntable_user_id"
        label="转盘用户id"
        width="180"
        align="center"
      />
      <el-table-column
        prop="admin_name"
        label="管理员"
        width="180"
        align="center"
      />
      <el-table-column
        prop="exchange_book_currency"
        label="兑换书币"
        width="180"
        align="center"
      />
      <el-table-column
        prop="send_msg_text"
        label="推送链接"
        width="300"
        align="center"
      />
      <el-table-column
        prop="exchange_book_currency"
        label="推送状态"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <i v-if="scope.row.send_msg_status == 2" class="el-icon-success sendstatus" />
          <i v-if="scope.row.send_msg_status == 3" class="el-icon-circle-close dangerstatus" />
          <i v-if="scope.row.send_msg_status == 1" class="el-icon-warning warningstatus" />
          {{ scope.row.send_msg_status_text }}
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at_text"
        label="失败原因"
        align="center"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.send_msg_status== 2" />
          <!-- <div v-if="scope.row.send_msg_status== 3">{{ JSON.parse(scope.row.send_msg_result).msg }}</div> -->
          <div v-if="scope.row.send_msg_status== 3">{{ scope.row.send_msg_result }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        align="center"
      />
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { exchangeRecordList, exchangenineRecordList } from '@/api/sourceMaterial.js'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      tableData: [],
      total: null,
      pageIfon: {
        page: 1,
        pageSize: 10
      },
      keyword: null
    }
  },
  created() {
    console.log(this.$route.query)
    this.keyword = this.$route.query.id
    if (this.$route.query.type === 1) {
      this.exchangedata()
    } else {
      this.exchangeninedata()
    }
  },
  mounted() {

  },
  methods: {
    // 转盘数据
    async exchangedata() {
      const data = await exchangeRecordList({
        keyword: this.keyword,
        page: this.pageIfon.page,
        pageSize: this.pageIfon.pageSize
      })
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 九宫格数据
    async exchangeninedata() {
      const data = await exchangenineRecordList({
        keyword: this.keyword,
        page: this.pageIfon.page,
        pageSize: this.pageIfon.pageSize
      })
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      if (this.$route.query.type === 1) {
        this.exchangedata()
      } else {
        this.exchangeninedata()
      }
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      if (this.$route.query.type === 1) {
        this.exchangedata()
      } else {
        this.exchangeninedata()
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.dsawr{
  padding: 20px;
}
.sendstatus{
  color: #67C23A;
}
.dangerstatus{
  color: #F56C6C;
}
.warningstatus{
  color: #E6A23C;
}
</style>
